import { ApiAsset } from '@/components/app/cards/PacksList/types';
import { useUserState } from '@/hooks/store';
import { Guide } from '@/store/guide/types';
import { Program } from '@/store/program/types';
import {
	getGuideSubtitle,
	getGuideTitle,
	isGuideCompleted,
	isGuideLocked,
	isGuidePlayable,
	isNextUpGuide,
	shouldShowDuration,
} from '@/utils/app/guideRowRules';

interface UseGuideInfo {
	(
		guide: Guide,
		program: Program,
		programProgress?: number,
	): {
		title: string;
		description?: string;
		isLocked: boolean;
		isDisabled: boolean;
		isCompleted: boolean;
		isNextUp: boolean;
		showDuration: boolean;
		image?: ApiAsset;
	};
}

export const useGuideInfo: UseGuideInfo = (guide, program, programProgress = 0) => {
	const user = useUserState();

	if (!guide) {
		return {
			title: '',
			isLocked: false,
			isDisabled: false,
			isCompleted: false,
			isNextUp: false,
			showDuration: false,
		};
	}

	const isLocked = isGuideLocked(guide, Boolean(user?.subscription?.valid));
	const isDisabled = !isLocked && !isGuidePlayable(guide, program, programProgress);
	const image = guide.cell_image ?? program?.guides?.[0]?.cell_image ?? program?.background_image;

	return {
		title: getGuideTitle(guide, program),
		description: getGuideSubtitle(guide, program),
		isLocked,
		isDisabled,
		isCompleted: isGuideCompleted(guide, program, programProgress),
		isNextUp: isNextUpGuide(guide, program, programProgress),
		showDuration: shouldShowDuration(program),
		image,
	};
};
